module.exports = __webpack_public_path__ + "static/handshake-76bc3929c7459f51ece0356073b1e443.jpg";